import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import { Link } from 'react-router-dom'
import { Relative } from './common'
import BackgroundImage from './BackgroundImage'
import { color, mixin } from '../globalStyles'

export const CardWrap = styled(Link)`
  ${mixin.card};
  ${mixin.cardHover};
  background: ${color.lightGrey};
  display: flex;
  min-height: 13rem;
`
const Title = styled.h2`
  margin: 0;
  color: white;
  line-height: 1;
`
const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0.3;
  background-image: linear-gradient(
    180deg,
    rgba(0, 0, 0, 1) 0%,
    rgba(0, 0, 0, 0) 100%
  );
`

const Card = ({ to, image, title, subtitle, className = '' }) => (
  <CardWrap to={to} className={`Card ${className}`}>
    <BackgroundImage image={image} />
    <Overlay />
    <Relative>
      <Title>{title}</Title>
      {subtitle ? <h6 className='CardSubtitle'>{subtitle}</h6> : ''}
    </Relative>
  </CardWrap>
)

Card.propTypes = {
  image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  to: PropTypes.string.isRequired
}

export default Card



// WEBPACK FOOTER //
// ./src/components/Card.js